interface Props {
  value: string;
  onInput: (value: string) => void;
}

export function HoneypotInput({ value, onInput }: Props) {
  return (
    <input
      type="text"
      name="website_url"
      value={value}
      onInput={(e) => onInput((e.currentTarget as HTMLInputElement).value)}
      tabIndex={-1}
      autoComplete="off"
      aria-hidden="true"
      style="position: absolute; left: -9999px; width: 1px; height: 1px; opacity: 0; pointer-events: none;"
    />
  );
}
